/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 3.16.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAllIoes200ResponseIoeInnerSetting } from './GetAllIoes200ResponseIoeInnerSetting';
import {
    GetAllIoes200ResponseIoeInnerSettingFromJSON,
    GetAllIoes200ResponseIoeInnerSettingFromJSONTyped,
    GetAllIoes200ResponseIoeInnerSettingToJSON,
    GetAllIoes200ResponseIoeInnerSettingToJSONTyped,
} from './GetAllIoes200ResponseIoeInnerSetting';

/**
 * 
 * @export
 * @interface GetAllIoes200ResponseIoeInner
 */
export interface GetAllIoes200ResponseIoeInner {
    /**
     * 
     * @type {string}
     * @memberof GetAllIoes200ResponseIoeInner
     */
    ioeIdPk?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllIoes200ResponseIoeInner
     */
    ioeType?: GetAllIoes200ResponseIoeInnerIoeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAllIoes200ResponseIoeInner
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllIoes200ResponseIoeInner
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllIoes200ResponseIoeInner
     */
    criticality?: string;
    /**
     * 
     * @type {number}
     * @memberof GetAllIoes200ResponseIoeInner
     */
    scoreImpact?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllIoes200ResponseIoeInner
     */
    totalFindingsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllIoes200ResponseIoeInner
     */
    totalExceptionsCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetAllIoes200ResponseIoeInner
     */
    allFindingsHaveException?: boolean;
    /**
     * 
     * @type {GetAllIoes200ResponseIoeInnerSetting}
     * @memberof GetAllIoes200ResponseIoeInner
     */
    setting?: GetAllIoes200ResponseIoeInnerSetting;
    /**
     * 
     * @type {string}
     * @memberof GetAllIoes200ResponseIoeInner
     */
    skippedReason?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetAllIoes200ResponseIoeInner
     */
    isActive?: boolean;
}


/**
 * @export
 */
export const GetAllIoes200ResponseIoeInnerIoeTypeEnum = {
    Ad: 'ad',
    Entra: 'entra',
    Hybrid: 'hybrid'
} as const;
export type GetAllIoes200ResponseIoeInnerIoeTypeEnum = typeof GetAllIoes200ResponseIoeInnerIoeTypeEnum[keyof typeof GetAllIoes200ResponseIoeInnerIoeTypeEnum];


/**
 * Check if a given object implements the GetAllIoes200ResponseIoeInner interface.
 */
export function instanceOfGetAllIoes200ResponseIoeInner(value: object): value is GetAllIoes200ResponseIoeInner {
    return true;
}

export function GetAllIoes200ResponseIoeInnerFromJSON(json: any): GetAllIoes200ResponseIoeInner {
    return GetAllIoes200ResponseIoeInnerFromJSONTyped(json, false);
}

export function GetAllIoes200ResponseIoeInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllIoes200ResponseIoeInner {
    if (json == null) {
        return json;
    }
    return {
        
        'ioeIdPk': json['ioeIdPk'] == null ? undefined : json['ioeIdPk'],
        'ioeType': json['ioeType'] == null ? undefined : json['ioeType'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'criticality': json['criticality'] == null ? undefined : json['criticality'],
        'scoreImpact': json['scoreImpact'] == null ? undefined : json['scoreImpact'],
        'totalFindingsCount': json['totalFindingsCount'] == null ? undefined : json['totalFindingsCount'],
        'totalExceptionsCount': json['totalExceptionsCount'] == null ? undefined : json['totalExceptionsCount'],
        'allFindingsHaveException': json['allFindingsHaveException'] == null ? undefined : json['allFindingsHaveException'],
        'setting': json['setting'] == null ? undefined : GetAllIoes200ResponseIoeInnerSettingFromJSON(json['setting']),
        'skippedReason': json['skippedReason'] == null ? undefined : json['skippedReason'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function GetAllIoes200ResponseIoeInnerToJSON(json: any): GetAllIoes200ResponseIoeInner {
    return GetAllIoes200ResponseIoeInnerToJSONTyped(json, false);
}

export function GetAllIoes200ResponseIoeInnerToJSONTyped(value?: GetAllIoes200ResponseIoeInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ioeIdPk': value['ioeIdPk'],
        'ioeType': value['ioeType'],
        'title': value['title'],
        'description': value['description'],
        'criticality': value['criticality'],
        'scoreImpact': value['scoreImpact'],
        'totalFindingsCount': value['totalFindingsCount'],
        'totalExceptionsCount': value['totalExceptionsCount'],
        'allFindingsHaveException': value['allFindingsHaveException'],
        'setting': GetAllIoes200ResponseIoeInnerSettingToJSON(value['setting']),
        'skippedReason': value['skippedReason'],
        'isActive': value['isActive'],
    };
}

